// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3WpLt","noBullet":"styles_noBullet__3psI8","expandCollapse":"styles_expandCollapse__2Ps3X"};